// Who the chat's stored history belongs to. Its own module so that chatService stays free of the app's globals and
// can be tested on its own, and so the two components that read the history do not have to import the chat's root
// (which imports them back).

import { DEFERRED_STATUS } from "src/util/Deferred";
import { GLOB } from "src/util/Glob";

/**
 * The signed-in person's id, or undefined while that is not known yet - just after a sign-in, before XorMon has
 * read the person, when userInfo may still hold the one signed in before. Read at the moment the history is read
 * or written, never kept: xormonReady can resolve while the chat is already open.
 */
export function signedInHistoryOwner(): number | null | undefined {
  return GLOB.xormonReady.status === DEFERRED_STATUS.resolved ? GLOB.userInfo?.user_id : undefined;
}
